/*****
 * Created with WebStorm.
 * Date : 2018/9/16.
 * Author : Ztr.
 * Func : ..
 ******/
const _BASE = window.ServerConfig.base;
const _TESTBASE = window.ServerConfig.testBase;
const _IMGBASE = window.ServerConfig.imgBase;
const _APPID = window.ServerConfig.appId;
const _TIMEOUTURL = window.ServerConfig.timeoutBase;
const _VERSION = window.ServerConfig.version;
const _SECRETMAP = window.ServerConfig.secretMap;
let miniLock = false; //防止多次跳转到小程序

import Cookies from 'js-cookie';
export default {
  /**基础配置 */
  base: _BASE,
  testBase: _TESTBASE,
  url: _BASE + '/api',
  uploadUrl: _BASE + 'ma-app/api/v1.0/saveFiles',
  imgUrl: _IMGBASE + '/file/read/',
  appId: _APPID,
  timeoutUrl: _TIMEOUTURL,
  recipeBase: window.ServerConfig.recipeBase,
  userBase: window.ServerConfig.userBase,
  version: _VERSION,
  secretMap:_SECRETMAP,

  /**数据传输类配置 */
  contentType: 'application/x-www-form-urlencoded', //form提交数据：application/x-www-form-urlencoded
  transType: 'unify.check.common', //根据需求文档确定
  signType: 'Plain',//根据需求文档确定
  encryptType: 'Plain',//根据需求文档确定
  termType: 'WX',//根据需求文档确定
  tokenCheck: false, //是否开启token校验,不开启的情况下，以下属性都将无效
  //统一请求配置
  responseConfig: {
    //响应代码
    code: 'respCode',
    //响应数据
    data: 'param',
    //错误提示信息
    msg: 'respMsg',
    //响应是否是成功的
    isOK: function (response) {
      return (response instanceof Object) && (response['respCode'] === '000000')
    },
    //tokenCheck为true时，token验证不通过时返回的异常码， 出现这种情况情况下将直接执行回调errorCallBack，110002没有登录或登录过期了
    errorCodes: ['110002', '110003', '110004', '050055', '050001'],
    errorCallback: function (store, router, response) {
      // token过期后,自定义处理,或返回错误
    //  router.push({
    //     path: '/login2'
    //   })
      let isMini = false;
      const ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        //判断是否是微信环境
        wx.miniProgram.getEnv(res => {
          if (res.miniprogram) {
            console.log("小程序环境下");
            isMini = true;
          }
        });
      }

      if (this.errorCodes.indexOf(response['respCode']) >= 0) {
          //alert(response['respMsg'])
        if (process.env.NODE_ENV == 'production') { //生产环境token过期跳转
          // location.href = _TIMEOUTBASE;
          if (isMini === true && miniLock == false) { // 跳转小程序登录页面
            wx.miniProgram.redirectTo({
              url: "/pages/h5LoginOut/main"
            });
            miniLock = true;
          } else {
            // 根据用户入口跳转到对应登录页
            let _pageMap = window.ServerConfig.pageMap;
            let _platId = store.getters.platId;
            let _linkSession = sessionStorage.getItem("LINK-SESSION");
            if(store.state.nimSDK.nim){
              store.state.nimSDK.nim.destroy({
                done: () => {
                  console.error('destroy really done!',store.state.nimSDK.nim)
                  // store.state.nimSDK.nim = null;
                  // store.commit('clearToken');

                  if (_linkSession == 1 && _pageMap[_platId]) {//用户体系,根据平台id跳转
                    window.location.href = _pageMap[_platId];
                  } else {
                    router.push({
                      path: '/userReg',
                      query: {
                        platId: _platId
                      }
                    })
                  }
                }
              });
            }else{
              if (_linkSession == 1 && _pageMap[_platId]) {//用户体系
                window.location.href = _pageMap[_platId];
              } else {
                router.push({
                  path: '/userReg',
                  query: {
                    platId: _platId
                  }
                })
              }
            }
          }
        } else { //开发环境token过期跳转

          if (isMini === true && miniLock == false) { // 跳转小程序登录页面
            wx.miniProgram.redirectTo({
              url: "/pages/h5LoginOut/main"
            });
            miniLock = true;
          } else {
            // 根据用户入口跳转到对应登录页
            let _pageMap = window.ServerConfig.pageMap;
            let _platId = store.getters.platId;
            let _linkSession = sessionStorage.getItem("LINK-SESSION");
            if(store.state.nimSDK.nim){
              store.state.nimSDK.nim.destroy({
                done: () => {
                  console.error('destroy really done!',store.state.nimSDK.nim)
                  // store.state.nimSDK.nim = null;
                  // store.commit('clearToken');
                  if (_linkSession == 1 && _pageMap[_platId]) {//用户体系,根据平台id跳转
                    window.location.href = _pageMap[_platId];
                  } else {
                    router.push({
                      path: '/userReg',
                      query: {
                        platId: _platId
                      }
                    })
                  }
                }
              });
            }else{
              if (_linkSession == 1 && _pageMap[_platId]) {//用户体系,根据平台id跳转
                window.location.href = _pageMap[_platId];
              } else {
                router.push({
                  path: '/userReg',
                  query: {
                    platId: _platId
                  }
                })
              }
            }
          }
        }
      }
    }
  },
  //白名单配置
  routerWhiteList: ['login', 'login2']
}




// WEBPACK FOOTER //
// ./src/config/api.js